import CompanyEmployeesTab from "./company-employees-tab";

export default CompanyEmployeesTab;